/* Segnaposto delle nove schermate.
 *
 * Le rotte esistono già con il loro percorso definitivo, così chi scriverà le
 * schermate non deve toccare il router né inventarsi un URL: sostituisce il
 * corpo e basta. Il segnaposto elenca gli endpoint che quella schermata userà,
 * perché è l'informazione che serve per prima e si perderebbe altrimenti.
 */

import { IntestazionePagina } from '../componenti/Guscio';
import { Avvertenza, Distintivo } from '../componenti/Base';

export interface PropsSegnaposto {
  titolo: string;
  /** A cosa serve la schermata, in una riga. */
  scopo: string;
  /** Gli endpoint del backend che la alimenteranno. */
  endpoint: string[];
  /** Ciò che manca lato backend, se manca qualcosa. */
  mancante?: string;
}

export function Segnaposto({ titolo, scopo, endpoint, mancante }: PropsSegnaposto) {
  return (
    <div className="sb-cornice">
      <IntestazionePagina
        titolo={titolo}
        sotto={<Distintivo tono="accento">da scrivere</Distintivo>}
      />
      <div className="sb-segnaposto">
        <p style={{ color: 'var(--sb-testo-medio)', maxWidth: '62ch', lineHeight: 1.6 }}>{scopo}</p>

        <div className="sb-occhiello">Endpoint previsti</div>
        <ul className="sb-segnaposto__elenco">
          {endpoint.map((e) => (
            <li key={e} style={{ fontFamily: 'var(--sb-font-numeri)', fontSize: 'var(--sb-t-12)' }}>
              {e}
            </li>
          ))}
        </ul>

        {mancante && <Avvertenza livello="cautela">{mancante}</Avvertenza>}
      </div>
    </div>
  );
}
